// Values used by the public legal pages (/privacy, /support).
//
// These are kept in one file because they are the only things in those pages that
// are a human decision rather than a description of what the code does. They appear
// on a PUBLIC page and in App Store Connect, so get them right before deploying.
//
// ⚠️ CONFIRM BEFORE DEPLOY:
//   CONTACT_EMAIL  — must be a mailbox that actually exists and is monitored. Apple
//                    requires a working support contact, and people will email this
//                    to ask for their data or report a problem. Do NOT ship a
//                    placeholder.
//   LEGAL_OPERATOR — who operates the service. For an individual developer this is
//                    normally your name (it already appears publicly as the App
//                    Store seller). Use a company name instead if one exists.

export const CONTACT_EMAIL = 'gifts@memula.com';

export const LEGAL_OPERATOR = 'Venkat Memula';

export const POLICY_EFFECTIVE_DATE = '27 August 2026';
